<template>
  <div id="app">
    <router-view> </router-view>
    <SiheDebugger :buildTag="process.env.VUE_APP_BUILD_TAG" />
  </div>
</template>

<script>
import SiheDebugger from 'sihe-vue-debugger'
import buildTag from 'sihe-buildtag'

new buildTag(
  [
    `Build Tag: ${process.env.VUE_APP_BUILD_TAG || ''}<br/>`,
    `Ecs Server: ${process.env.VUE_APP_ECS_SERVER} | `,
    `Decoder Server: ${process.env.VUE_APP_DECODER_SERVER}`,
  ],
  {
    separator: '',
  },
).create()

export default {
  data() {
    return {
      process: process,
    }
  },
  components: { SiheDebugger },
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  overflow: auto;
}
</style>
